// src/i18n/es/arrivals.ts
// «Llegadas de hoy» (mockup 01) — controller screen under Recepción.
export const arrivals = {
  name: 'Llegadas de hoy',
  tabs: {
    today: 'Hoy',
    tomorrow: 'Mañana',
  },
  pendingOnly: 'Solo pendientes',
  emptyState: {
    description: 'Pruebe a ampliar la fecha o a quitar «Solo pendientes».',
  },
  updatedAgo: 'Actualizado hace %{seconds} s',
  wallScreen: 'Pantalla de pared',
  wallScreenNeedsHotel: 'Elija un solo hotel para abrir la pantalla de pared.',
  operatorCode: 'Código de operador',
  operatorCodeChoose: 'Elija el dispensador',

  // Arrivals list of the wall screen (mockup 02).
  wallList: {
    title: 'Llegadas de hoy (%{count})',
    guest: 'Huésped',
    reservation: 'Reserva',
  },

  liveStrip: {
    title: 'Ahora mismo',
    empty: 'Nadie en curso ahora mismo.',
    minutesInSection: '%{section} · %{minutes} min',
  },

  counters: {
    arrivals: 'Llegadas de hoy',
    // Only guests who have used a channel: fewer than the board's «Previstas», by design.
    arrivalsKnown: 'Conocidas (han usado algún canal)',
    arrivalsKnownShort: 'Conocidas',
    arrivalsKnownHint: 'Solo se cuentan las personas que han usado algún canal.',
    title: 'Estado de las llegadas',
    ready: 'Listas',
    preCheckInPartial: 'Pre-check-in a medias',
    notStarted: 'Sin empezar',
    checkedIn: 'Check-in hecho',
    attention: 'Necesitan atención',
  },

  columns: {
    time: 'Hora',
    guest: 'Huésped',
    room: 'Hab.',
    preCheckIn: 'Pre-check-in',
    payment: 'Pago',
    identification: 'Ident.',
    state: 'Estado',
    key: 'Llave',
  },

  preCheckIn: {
    done: 'Hecho',
    doneAgo: 'Hecho · hace %{time}',
    doneToday: 'Hecho · hoy',
    partial: 'A medias',
    partialAt: 'A medias · %{section}',
    none: '—',
  },
  payment: {
    paid: 'Pagado',
    pending: 'Pendiente',
    failed: 'Fallido',
    none: '—',
  },
  key: {
    card: 'Tarjeta',
    digital: 'Llave digital',
    none: '—',
  },

  stuckFlag: 'Lleva %{minutes} min en %{section}',
  needsHelp: 'Necesita ayuda',

  actions: {
    acknowledge: 'Marcar como visto',
    acknowledged: 'Visto',
    pin: 'Fijar',
    unpin: 'Quitar de fijados',
  },


  detail: {
    title: 'Detalle de la reserva',
    close: 'Cerrar',
    openFull: 'Ver ficha completa',
  },

  help: {
    title: 'Llegadas de hoy',
    description: 'El panel de control de recepción: quién llega hoy, quién está en un kiosco ahora mismo y quién necesita ayuda.',
    features: {
      liveStrip: 'La franja «Ahora mismo» cuenta las sesiones activas de cada canal y muestra primero a quien necesita ayuda o lleva demasiado tiempo en un paso.',
      sortOrder: 'La tabla pone primero a quien necesita ayuda, después a quien lleva demasiado tiempo en un paso, y el resto por fecha de llegada y nombre del huésped.',
      actions: 'Marque como visto o fije una fila para seguirla de cerca.',
    },
    tips: {
      pendingOnly: 'Use «Solo pendientes» para ocultar lo ya resuelto.',
      wallScreen: 'Abra «Pantalla de pared» para un resumen en una pantalla de recepción.',
      operatorCode: 'Con «Código de operador» obtiene el código del día que abre el menú de operador de un dispensador de llaves de su hotel.',
    },
  },
};

export default arrivals;
